import { render, staticRenderFns } from "./addRelation.vue?vue&type=template&id=c2b6a0b8&"
import script from "./addRelation.vue?vue&type=script&lang=js&"
export * from "./addRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b6a0b8')) {
      api.createRecord('c2b6a0b8', component.options)
    } else {
      api.reload('c2b6a0b8', component.options)
    }
    module.hot.accept("./addRelation.vue?vue&type=template&id=c2b6a0b8&", function () {
      api.rerender('c2b6a0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/addRelation.vue"
export default component.exports